<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR AVALIAÇÃO EXTERNA' : 'NOVA AVALIAÇÃO EXTERNA'" titleIcon="fas fa-award">
            <el-form ref="dados" :model="dados" label-position="top" @submit.native.prevent="salvar">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Nome" prop="nome" :rules="$requiredBlur">
                            <el-input v-model="dados.nome" placeholder="Ex.: Sistema de Avaliação da Educação Básica"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Sigla">
                            <el-input v-model="dados.sigla" placeholder="SAEB"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Esfera" prop="esfera" :rules="$requiredChange">
                            <el-select v-model="dados.esfera" style="width: 100%;">
                                <el-option v-for="e in esferas" :key="e" :value="e" :label="rotulo(e)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Periodicidade">
                            <el-select v-model="dados.periodicidade" clearable style="width: 100%;">
                                <el-option v-for="p in periodicidades" :key="p" :value="p" :label="rotulo(p)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="Descrição">
                    <el-input v-model="dados.descricao" type="textarea" :rows="3"></el-input>
                </el-form-item>

                <el-form-item label="Situação">
                    <el-switch v-model="dados.situacao" active-text="Ativa" inactive-text="Inativa"></el-switch>
                </el-form-item>

                <div class="u-text-right u-mt-20">
                    <router-link to="/admin/avaliacao-externa"><el-button>CANCELAR</el-button></router-link>
                    <el-button class="u-ml-10" v-if="podeEscrever" type="primary" native-type="submit">SALVAR</el-button>
                </div>
            </el-form>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO G — itens 30, 31 e 70. */
export default {
    data: () => ({
        esferas: ['federal', 'estadual', 'municipal'],
        periodicidades: ['anual', 'bienal', 'eventual'],
        dados: { nome: '', sigla: '', esfera: '', periodicidade: '', descricao: '', situacao: true }
    }),
    computed: {
        podeEscrever () { return [4, 5, 6, 7].includes(parseInt(this.$store.state.user.tipo)) },
        modoEdicao () { return !!this.$route.params.id }
    },
    mounted () {
        if (this.modoEdicao) {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/ext-avaliacao/getById/${this.$route.params.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                if (reg.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(reg.erro), type: 'warning' })
                    this.$router.push('/admin/avaliacao-externa')
                    return
                }
                Object.keys(this.dados).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k] })
            }).catch(e => this.$store.commit('throwException', e))
        }
    },
    methods: {
        rotulo (v) {
            return { federal: 'Federal', estadual: 'Estadual', municipal: 'Municipal',
                anual: 'Anual', bienal: 'Bienal', eventual: 'Eventual' }[v] || v
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/ext-avaliacao/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/ext-avaliacao/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Avaliação salva.', type: 'success' })
                    this.$router.push('/admin/avaliacao-externa')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
